import React from "react"
import CalculatorsInfoSectionWrapperStyle from "./CalculatorsInfoSectionWrapperStyle.module.styl"

const CalculatorsInfoSectionWrapper = ({ children }) => {
  return (
    <div
      id="calculators"
      className={CalculatorsInfoSectionWrapperStyle.wrapper}
    >
      {children}
    </div>
  )
}

export default CalculatorsInfoSectionWrapper
